import api from './api';

export const orderService = {
  // Create new order
  createOrder: async orderData => {
    const response = await api.post('/orders/create', orderData);
    return response.data?.data || response.data;
  },

  // Get user's orders
  getUserOrders: async (params = {}) => {
    const response = await api.get('/orders', { params });
    return response.data?.data || response.data;
  },

  // Get order details
  getOrderDetails: async orderId => {
    const response = await api.get(`/orders/${orderId}`);
    return response.data?.data || response.data;
  },

  // Get order summary (for checkout)
  getOrderSummary: async () => {
    const response = await api.get('/orders/summary');
    return response.data?.data || response.data;
  },

  // Khalti payment - initiate
  initiateKhaltiPayment: async (orderId) => {
    const response = await api.post('/orders/khalti/initiate', { orderId });
    return response.data?.data || response.data;
  },

  // Khalti payment - verify
  verifyKhaltiPayment: async (pidx) => {
    const response = await api.post('/orders/khalti/verify', { pidx });
    return response.data;
  },

  // eSewa payment - initiate (returns gateway URL + signed form params)
  initiateEsewaPayment: async (orderId) => {
    const response = await api.post('/orders/esewa/initiate', { orderId });
    return response.data?.data || response.data;
  },

  // eSewa payment - verify (data = base64 query param eSewa redirected with)
  verifyEsewaPayment: async (data) => {
    const response = await api.post('/orders/esewa/verify', { data });
    return response.data;
  },
};
